import { Component, Input } from '@angular/core';
import { DetailPanelComponent } from '../../../../core/panels/detail-panel/detail-panel.component';
import { DetailItemComponent } from '../../../../core/panels/detail-panel/detail-item.component';

@Component({
  selector: 'app-coverage-detail',
  imports: [DetailItemComponent, DetailPanelComponent],
  template: `<div class="tw-flex tw-gap-8">
    <div class="tw-basis-1/3">
      <app-detail-panel [dataSource]="dataSource">
        <app-detail-item label="ASLOB Code" name="aslobCode" labelCase="none" />
        <app-detail-item label="Subline of business" name="subLineOfBusiness" />
        <app-detail-item label="Line of business" name="lineOfBusiness" />
        <app-detail-item label="Notes" name="notes" />
      </app-detail-panel>
    </div>
    <div class="tw-basis-1/3">
      <app-detail-panel [dataSource]="dataSource">
        <app-detail-item label="Coverage layer" name="coverageLayer" />
        <app-detail-item
          label="Include expenses"
          name="includeExpenses"
          format="b"
        />
        <app-detail-item label="Description" name="description" />
      </app-detail-panel>
    </div>
  </div>`,
  styles: [],
})
export class CoverageDetailComponent {
  @Input() dataSource: any;
}
